const APPLY_URL = "https://pro.form-mailer.jp/fms/e40aa43b232020";

const scrollTo = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  return (
    <footer className="bg-stone-800 text-stone-300 pt-14 pb-8">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10 mb-10 pb-10 border-b border-stone-700">
          {/* Logo & info */}
          <div>
            <img
              src="https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/aab59213271533144a18b7088e97a4f4.jpeg"
              alt="クリニックロゴ"
              className="h-12 w-auto object-contain rounded mb-4"
            />
            <p className="text-xs text-stone-400 leading-6">
              入れ歯専門クリニック<br />
              札幌市内にて診療中<br />
              2026年4月より旭川出張相談会開催
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">クイックリンク</h4>
            <ul className="space-y-2">
              {[
                { label: "料金のご案内", id: "pricing" },
                { label: "お申し込み", id: "application" },
                { label: "クリニックについて", id: "about" },
                { label: "出張相談会", id: "consultation" },
                { label: "お問い合わせ", id: "contact" },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="cursor-pointer text-xs text-stone-400 hover:text-white transition-colors whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line mr-1" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Pricing summary */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-4">料金</h4>
            <ul className="space-y-3 text-xs text-stone-400">
              <li className="flex justify-between">
                <span>入れ歯 1床</span>
                <span className="text-white font-semibold">¥330,000（税込）</span>
              </li>
              <li className="flex justify-between">
                <span>入れ歯 上下セット</span>
                <span className="text-amber-400 font-semibold">¥550,000（税込）</span>
              </li>
            </ul>
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap cursor-pointer mt-6 inline-block bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold px-5 py-2.5 rounded-md transition-colors"
            >
              今すぐ申し込む
            </a>
          </div>
        </div>

        <div className="text-center text-xs text-stone-500">
          &copy; {new Date().getFullYear()} 入れ歯専門クリニック. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
